import { useInfiniteQuery } from '@tanstack/react-query';

import ModelsService, { FilterModelsDto } from '@/services/ModelsService';

export const GET_MODELS_QUERY_KEY = (filters: FilterModelsDto) => [
  'models',
  filters,
];

export function useGetModels(filters: Omit<FilterModelsDto, 'page'>) {
  const { data, isFetching, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useInfiniteQuery({
      queryKey: GET_MODELS_QUERY_KEY(filters),
      initialPageParam: 1,
      queryFn: ({ pageParam }) =>
        ModelsService.getModels({ ...filters, page: pageParam, limit: 10 }),
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        const { currentPage, totalPages } = lastPage;
        if (currentPage === totalPages || totalPages === 0) return null;
        return (lastPageParam as number) + 1;
      },
    });

  const models = data?.pages.flatMap((p) => p.items) ?? [];

  return { models, isFetching, isFetchingNextPage, hasNextPage, fetchNextPage };
}
